import { AntTag } from '@agro-club/agroclub-shared'
import { ListDeal } from 'modules/domain/deal/types'
import { IconSample } from '../../Board/styled'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'

interface Props {
  deal: ListDeal
}

export const SampleTag: FC<Props> = ({ deal }) => {
  const { t } = useTranslation()
  if (!deal.sample_request_status) return null
  return (
    <AntTag icon={<IconSample />} color="blue">
      {t(`samples:sampleRequestStatusesForTags.${deal.sample_request_status}`)}
    </AntTag>
  )
}
